module.exports = __webpack_public_path__ + "media/img/auth-bg-799d116a3381350998085df062680c6c.png";